import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import CustomButton from "../../../components/UI/customButton/customButton";
import { toast } from "react-toastify";
import { Get, Post } from "../../../apis/api";
import LoadingFix from "../../../components/loading-fix/loading-fix";
import moment from "moment-jalaali";
import mohr from "../../../assets/img/mohr.jpg";
import emza from "../../../assets/img/emza.jpg";
import html2pdf from 'html2pdf.js';
import { useNavigate, useParams } from "react-router-dom";
import formLogo from "../../../assets/img/form-logo.png"
import wave from "../../../assets/img/wave.png"
import { useSelector } from "react-redux";
import { useMutation, useQuery } from 'react-query';

const FormNumberThree = ({ id, onPdf, setLoading = (f) => { }, atNumber, createPDFasync, setCreatePDFasync }) => {
  // const [data, setData] = useState(false);
  const { t } = useTranslation()
  const [visaType, setVisaType] = useState(null);
  // const [loading, setLoading] = useState(false);
  const [createPdf, setCreatePdf] = useState(false);
  const cityList = useSelector((state) => state.setting.city)

  const contentRef = useRef(null);
  const contentRef2 = useRef(null);

  console.log({ createPDFasync, setCreatePDFasync })

  const handleCity = (id) => {
    return cityList?.find((item => {
      return (
        item.id === id
      )
    }))?.["en_name"]
  }

  // useEffect(() => {

  //   if (contentRef?.current && contentRef2?.current && data) {
  //     const pdfBlob = convertToPdf().then((res) => {
  //       setLoading(false)
  //       onPdf(res)
  //     });
  //   }
  // }, [data, contentRef, contentRef2])



  const { isLoading, isError, data: visaAllData, refetch } = useQuery({
    queryFn: ({ queryKey }) => {
      setLoading(true)
      return Get(`admin/visas/show/${queryKey[1]}`)
    },
    queryKey: ['GetVisa', id],
    onSuccess: (res) => {
      setVisaType(res?.details?.data?.visa?.visa_type);
      // if (buildPdf) {
      //   setTimeout(() => convertToPdf().then(pdf => onPdf(pdf)), 250)
      // }
    },
    onError: (error) => {
      toast.error(error.message || error.msg || error?.data?.message);
    },
    onSettled: () => {
      setLoading(false)
    },
    retry: 0,
    staleTime: 0,
    cacheTime: 0,
    enabled: false
  })
  // console.log({ contentRef, contentRef2 })

  const convertToPdf = async () => {
    setCreatePdf(true)


    try {







      const content = contentRef?.current;
      const content2 = contentRef2?.current;

      console.log("In Convert To PDF", { contentRef, content, contentRef2, content2 })
      // ذخیره استایل‌های اصلی
      const originalPadding = content?.style?.padding;
      const originalMargin = content?.style?.margin;
      const originalFontSize = content?.style?.fontSize;
      const originalMarginLeft = content2?.style?.marginLeft;


      // تغییر استایل
      content.style.padding = "0";
      content.style.margin = "40px";
      content2.style.marginLeft = "150px";
      content.style.fontSize = "12.5px";


      const options = {
        filename: 'my-document.pdf',
        margin: 0,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: {
          unit: 'in',
          format: 'letter',
          orientation: 'portrait',
        },
      };

      // تولید PDF
      const pdfBlob = await html2pdf().set(options).from(content).toPdf().output('blob');

      // بازگردانی استایل‌ها به حالت اولیه
      content.style.padding = originalPadding;
      content.style.margin = originalMargin;
      content.style.fontSize = originalFontSize;
      content2.style.marginLeft = originalMarginLeft;
      setCreatePdf(false)
      return pdfBlob; // Return the Blob
    } catch (error) {
      console.log(error)
    }
  };



  const handleExtractPDF = async () => {

    if (!data)
      await refetch()
    await (new Promise((res) => setTimeout(() => res("p2"), 200)))
    return convertToPdf()
  }



  const data = visaAllData?.details?.data


  useEffect(() => {
    if (setCreatePDFasync && !createPDFasync)
      setCreatePDFasync(() => handleExtractPDF)
  }, [handleExtractPDF])

  const text = {
    "subject": {
      "Extension for 6 months": "درخواست تمدید پروانه اقامت",
      "Extension for 3 months": "درخواست تمدید پروانه اقامت",
      "Obtaining for 6 months": "درخواست اخذ پروانه اقامت ",
      "Obtaining for 3 months": "درخواست اخذ پروانه اقامت ",
      "72-hour_accession_departure": "درخواست صدور روادید 72 ساعته جهت خروج کشور ",
      "72-hour_accession_entry": "درخواست صدور روادید 72 ساعته جهت الحاق به شناور ",
    },
    "emailBody": {
      "Extension for 6 months": ` اقدام کند. خواهشمند است نتیجه را به این شرکت منعکس نمایید. در پیوست مدارک ایشان تقدیم حضورتان گردیده است ${data?.ship?.name} به استحضار می‌رساند این شرکت در نظر دارد برای صدور تمدید پروانه اقامت شناور `,
      "Obtaining for 6 months": ` اقدام کند. خواهشمند است نتیجه را به این شرکت منعکس نمایید. در پیوست مدارک ایشان تقدیم حضورتان گردیده است ${data?.ship?.name} به استحضار می‌رساند این شرکت در نظر دارد برای اخذ پروانه اقامت خروجی شناور `,
      "Extension for 3 months": ` اقدام کند. خواهشمند است نتیجه را به این شرکت منعکس نمایید. در پیوست مدارک ایشان تقدیم حضورتان گردیده است ${data?.ship?.name} به استحضار می‌رساند این شرکت در نظر دارد برای صدور تمدید پروانه اقامت شناور `,
      "Obtaining for 3 months": ` اقدام کند. خواهشمند است نتیجه را به این شرکت منعکس نمایید. در پیوست مدارک ایشان تقدیم حضورتان گردیده است ${data?.ship?.name} به استحضار می‌رساند این شرکت در نظر دارد برای اخذ پروانه اقامت خروجی شناور `,
      "72-hour_accession_departure": ` اقدام کند. خواهشمند است نتیجه را به این شرکت منعکس نمایید. در پیوست مدارک ایشان تقدیم حضورتان گردیده است ${data?.ship?.name} به استحضار می‌رساند این شرکت در نظر دارد برای صدور درخواست صدور روادید 72 ساعته جهت خروج کشور شناور `,
      "72-hour_accession_entry": ` اقدام کند. خواهشمند است نتیجه را به این شرکت منعکس نمایید. در پیوست مدارک ایشان تقدیم حضورتان گردیده است ${data?.ship?.name} به استحضار می‌رساند این شرکت در نظر دارد برای صدور روادید ۷۲ ساعته خروجی شناور `,
    },
    "topTitle": {
      "Extension for 6 months": {
        1: "در صدد است نسبت به درخواست تمدید پروانه اقامت دریانورد/دریانوردان مشروحه زیر جهت شناور",
        2: "به مالکیت",
      },
      "Obtaining for 6 months": {
        1: "در صدد است نسبت به درخواست تمدید پروانه اقامت دریانورد/دریانوردان مشروحه زیر جهت شناور",
        2: "به مالکیت",
      },
      "Extension for 3 months": {
        1: "در صدد است نسبت به درخواست تمدید پروانه اقامت دریانورد/دریانوردان مشروحه زیر جهت شناور",
        2: "به مالکیت",
      },
      "Obtaining for 3 months": {
        1: "در صدد است نسبت به درخواست تمدید پروانه اقامت دریانورد/دریانوردان مشروحه زیر جهت شناور",
        2: "به مالکیت",
      },
      "72-hour_accession_departure": {
        1: "در صدد است نسبت به درخواست صدور روادید 72 ساعته دریانورد مشروحه زیر بمنظور خروج از کشور از شناور",
        2: "با پرچم کشور خارجی به مالکیت",
      },
      "72-hour_accession_entry": {
        1: "در صدد است نسبت به درخواست صدور روادید 72 ساعته دریانوردان مشروحه زیر جهت الحاق به شناور ",
        2: "( با پرچم خارجی ) به مالکیت",
      },
    },
  }

  const handleText = (data) => {


    const flyDist = data?.visa_fly?.toReversed()?.[0]?.destination

    const flyDistCityEnName = data?.visa_fly?.toReversed()?.[0]?.destination.city.en_name

    const flyDistCountryEnName = data?.visa_fly?.toReversed()?.[0]?.destination?.city?.province?.country?.[0]?.en_name


    return (
      <>
        <div className={"flex justify-start w-full leading-7  text-justify flex-col "} lang='en'>
          {
            data?.visa_fly?.map((item) => {
              return (
                <>
                  <strong>{` FLIGHT ${item?.fly_no} - ${item?.airline["en_name"]}`}</strong>
                  <div className={"flex justify-between"}>
                    <span>{`Departure : (${item?.origin["code"]}) ${item?.origin["en_name"]} Airport`}</span>
                    <span style={{ letterSpacing: '3px' }}>{`${moment(item?.fly_date	).format('DD MMMM YYYY ')} `}&nbsp;Time: {moment(item?.fly_date	).format('HH:mm')}</span>
                  </div>
                  <div className={"flex justify-between border-b  pb-2 "}>
                    <span>{`Arrival : (${item?.destination["code"]})  ${item?.destination["en_name"]} Airport`}</span>
                    <span style={{ letterSpacing: '3px' }}>{`${moment(item?.land_date).format('DD MMMM YYYY ')} `}&nbsp;Time: {moment(item?.land_date).format('HH:mm')}</span>
                  </div>
                </>
              )
            })
          }

          <p>
            <span>Considering that above you are kindly requested to confirm OK TO ON BORARD , We as a manager take all responsibilities to meet them at airport of </span>
            <b> {flyDist?.code} International Airport ,  {flyDistCityEnName}  {flyDistCountryEnName}  </b>
            <span>and manage to obtain visa arrival and do all necessary arrangments to join them the vessel.</span>
          </p>

          <b>
            <span>Contact person : Mr.ABDOLMOHAMMAD MOMENI  (</span>
            <span style={{ wordSpacing: '6px' }}>+98  912  697   1232 </span>
            <span>) , ABDOLMAJID MOMENI , (</span>
            <span style={{ wordSpacing: '6px' }}>+98  912  179  4191 </span>
            <span>)</span>
          </b>

        </div>
      </>
    )
  }

  const handleDownload = async () => {
    const pdfBlob = await convertToPdf();
    const url = URL.createObjectURL(pdfBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'my-document.pdf';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  // console.log(data)



  if (isError)
    return <span className='text-center text-rose-600 w-full h-72 flex flex-row justify-center bg-white items-center my-container rounded-lg fixed -top-[800px]'>{t('ErrorInLoadingVisa')}</span>

  else if (data) {

    const flyDist = data?.visa_fly?.toReversed()?.[0]?.destination

    const flyDistCityEnName = data?.visa_fly?.toReversed()?.[0]?.destination.city.en_name

    const flyDistCountryEnName = data?.visa_fly?.toReversed()?.[0]?.destination?.city?.province?.country?.[0]?.en_name

    // console.log({flyDist , arr:data?.visa_fly?.lastIndexOf()})
    return (
      <div className={"fixed -top-[800px] z-10 right-[5000px] en"} >
        {/* {loading && <LoadingFix />} */}
        <div className={`my-container mb-10 h-auto  `}>
          <div className={"text-center my-5 text-2xl font-semibold"}>
            فرم شماره 3
          </div>
          <div ref={contentRef} className={"ltr relative bg-white rounded-lg flex flex-col items-center gap-5 md:gap-2 py-5 md:py-10 px-4 md:px-[4%] mb-8 2xl:mx-[10%]"}>
            {/* Content of the letter */}
            <div className={"flex w-full justify-end"}>
              <img className={"flex w-56 mb-5"} src={formLogo} />
            </div>
            <div className={"flex justify-between w-full"}>

              <div className={"flex flex-col gap-2 "}>

                <span>
                  <span className={""}>{` To :`}</span>
                  <span className='font-bold'>{` Whom it may concern `}</span>
                </span>
                <div className='flex flex-row gap-1 items-center'>
                  <span className={""}>{` Date :`}</span>
                  <div className='flex flex-row gap-0.5 items-center'>
                    <span style={{ letterSpacing: "4px" }}> {`${moment(new Date()).format('DD/MM/YYYY')}`}</span>
                  </div>
                </div>
                <span>
                  <span className={""}>{` Sub :`}</span>
                  <span className='font-bold'>{` OK TO BOARD `}</span>
                </span>
              </div>
            </div>
            <div className={"flex justify-start w-full mt-2"}>
              <span>Dear Sir / Madam</span>
            </div>
            <p className={" justify-start w-full  text-justify"}>
              <span>We <b>SEPEHR PAYAM MARINE CO.</b> as ship's manager of vessel </span>
              {/* ${text.topTitle?.[visaType]?.[1]} */}
              <b>{data?.ship?.name}</b>
              <b>, IMO :{data?.ship?.imo} </b>
              <span> at &nbsp;</span>
              <b>{flyDist?.code}</b>
              <>{` International Airport ,`}</>
              {/* ${data?.visa_fly?.[0]?.destination?.city_id} */}
              {/* <> <b class="uppercase">{flyDist?.en_name}</b> </> */}
              <b>{`${flyDistCityEnName} ${flyDistCountryEnName} `}</b>
              <>{` Would Like to inform you that the following crew is going to join to the above vessel in Iran :`}</>
            </p>
            <div className={"w-full py-8"}>
              <table className="w-full border-separate border cells border-slate-400 ..." style={{ fontSize: '13px', verticalAlign: 'middle' }}>
                <thead>
                  <tr className={"p-2 [&>th]:p-2"}>
                    <th className={`font-semibold  text-center m-1 bg-gray-200 border border-slate-300 ${createPdf && "!text-[13px]"}`}>{"Crews Name"}</th>
                    <th className={`font-semibold  text-center m-1 bg-gray-200 border border-slate-300 ${createPdf && "!text-[13px]"}`}>{"Passport No"}</th>
                    <th className={`font-semibold  text-center m-1 bg-gray-200 border border-slate-300 ${createPdf && "!text-[13px]"}`}>{"CDC No"}</th>
                    <th className={`font-semibold  text-center m-1 bg-gray-200 border border-slate-300 ${createPdf && "!text-[13px]"}`}>{" CDC Exp date"}</th>
                    <th className={`font-semibold  text-center m-1 bg-gray-200 border border-slate-300 ${createPdf && "!text-[13px]"}`}>{" Rank"}</th>
                    <th className={`font-semibold  text-center m-1 bg-gray-200 border border-slate-300 ${createPdf && "!text-[13px]"}`}>{"Automation No"} </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.crews?.map((item, index) => (
                    <tr key={index} className='[&>td]:p-2 [&>td]:border [&>td]:text-center [&>td]:align-middle'>
                      <td className="border border-slate-300 text-center ">{item?.crew?.name + " " + item?.crew?.last_name}</td>
                      <td className="border border-slate-300 text-center">{item?.crew?.passport_no}</td>
                      <td className="border border-slate-300 text-center">{item?.crew?.cdc_no}</td>
                      <td className="border border-slate-300 text-center">
                        <span>
                          {item?.crew?.cdc_expire && moment(item?.crew?.cdc_expire).format('DD')}
                        </span>
                        <span className={"px-[3px]"}>
                          {" /  "}
                        </span>
                        <span>
                          {item?.crew?.cdc_expire && moment(item?.crew?.cdc_expire).format('MM')}
                        </span>
                        <span className={"px-[3px]"}>
                          {" /  "}
                        </span>
                        <span>
                          {item?.crew?.cdc_expire && moment(item?.crew?.cdc_expire).format('YYYY')}
                        </span>
                      </td>
                      <td>{item?.crew?.job?.name ?? '-'}</td>
                      <td>{atNumber ?? data?.automation_number ?? '-'}</td>

                    </tr>
                  ))}

                </tbody>
              </table>
            </div>
            {
              handleText(data)
            }

            <div ref={contentRef2} className={"flex justify-start w-full mt-1"}>

              <div className={"relative flex flex-col text-center font-bold mx-[1%] mt-10 mb-10"}>
                <span className={"absolute w-[120px] h-[120px] top-1 -right-[95px]"}>
                  <img className={"flex w-full h-full"} src={emza} alt="Signature" />
                </span>
                <span className={"absolute w-[120px] h-[120px] -top-10 -right-[200px]"}>
                  <img className={"flex w-full h-full"} src={mohr} alt="Mohr" />
                </span>
                <span className={"z-40 relative"}>{"With best Regards"}</span>
                <span className={"z-40 relative mt-2"}>{"Abdolmajid Momeni"}</span>
                <span className={"z-40 relative "}>{"Managing Director"}</span>
              </div>
            </div>
            <div className={"w-full relative h-32"}>
              <img src={wave} />
            </div>
          </div>

          {/* 
          <div className={"w-full flex justify-center"}>
            <CustomButton onClick={handleDownload} title={"Download PDF"} />

          </div>  */}
        </div>
      </div>
    );
  }

  return <></>
};

export default FormNumberThree;
